module.exports = __webpack_public_path__ + "assets/img/solutions4.abd0e5cb.png";